import { render, staticRenderFns } from "./InternationalWireBankAddress.vue?vue&type=template&id=c0b3d468&"
import script from "./InternationalWireBankAddress.vue?vue&type=script&lang=js&"
export * from "./InternationalWireBankAddress.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWireBankAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports